export const VERIFYOTP_INIT_ACTION = "VERIFYOTP_INIT_ACTION";
export const VERIFYOTP_SUCCESS_ACTION = VERIFYOTP_INIT_ACTION + "_SUCCESS";
export const VERIFYOTP_FAIL_ACTION = VERIFYOTP_INIT_ACTION + "_FAIL";

export const RESENDVERIFYOTP_INIT_ACTION = "RESENDVERIFYOTP_INIT_ACTION";
export const RESENDVERIFYOTP_SUCCESS_ACTION = RESENDVERIFYOTP_INIT_ACTION + "_SUCCESS";
export const RESENDVERIFYOTP_FAIL_ACTION = RESENDVERIFYOTP_INIT_ACTION + "_FAIL";

export function verifyOTP(value) {
  return {
    type: VERIFYOTP_INIT_ACTION,
    value: value,
  };
}

export function resendverifyOTP(value) {
  return {
    type:RESENDVERIFYOTP_INIT_ACTION,
    value:value,
  }
}